import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SemBaseComponent } from '../../../components/common/sem-base/sem-base.component';

@Component({
    selector: 'sem-loader',
    templateUrl: './sem-loader.component.html',
    styleUrls: ['./sem-loader.component.css'],
    standalone: false
})
export class SemLoaderComponent implements OnInit {

  constructor(public changeDetection:ChangeDetectorRef) { }

  @Input() showLoader: boolean = false;
  @Input() cssClasses: string = "";

  toggle(event) {
  }

  refresh(val:boolean){
    this.showLoader = val;
    this.changeDetection.detectChanges();
  }

  ngOnInit() {
  }

}
